import React, { useState, useEffect } from 'react';
import { Header } from 'components/home';
import { TopNavBar } from 'components/top_nav_bar';
import { MenuProvider } from 'contexts/menu/menu_context';
import { StepperHorizontal } from 'components/shared/stepper_horizontal';
import Step1 from './Step1';
import Step2 from './Step2';
import useCifaStore from 'stores/cifa/cifa.store';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from 'routes/constants';

export interface InstitutionI {
  id: number;
  name: string;
}

type AnswersType = {
  beneficiaries: string;
  ataUuid: string | null;
  parceria: string;
  beneficiariosParceria: string;
  docParceriaUuid: string | null;
  relatorioUuid: string | null;
  instituicoes: string[];
  outraInstituicao: string;
  relatorioUuid_empaer: string | null;
  relatorioUuid_ensino: string | null;
  relatorioUuid_ongs: string | null;
  relatorioUuid_privadas: string | null;
};

const TechAssist: React.FC = () => {
  const steps = [
    'ATER',
    'Confirmação',
  ];
  const [activeStep, setActiveStep] = useState<number>(0);

  const { cifa } = useCifaStore();
  const navigate = useNavigate();
  const location = useLocation();

  // Extrai o ano da rota, ex: /service_management/cifa-2027 => 2027
  const match = location.pathname.match(/cifa-(\d{4})/);
  const anoReferencia = match ? Number(match[1]) : 2026;

  // Carregar dados do partialForm ao montar
  const [answers, setAnswers] = useState<AnswersType>({
    beneficiaries: '',
    ataUuid: null,
    parceria: '',
    beneficiariosParceria: '',
    docParceriaUuid: null,
    relatorioUuid: null,
    instituicoes: [],
    outraInstituicao: '',
    relatorioUuid_empaer: null,
    relatorioUuid_ensino: null,
    relatorioUuid_ongs: null,
    relatorioUuid_privadas: null,
  });

  useEffect(() => {
    if (cifa) {
      setAnswers({
        beneficiaries: cifa.assistencia_tecnica_beneficiarios_atendidos?.toString() || '',
        ataUuid: cifa.assistencia_tecnica_ata_cmdrs_uuid || null,
        parceria: cifa.assistencia_tecnica_parceria_instituicao ? 'Sim' : 'Não',
        beneficiariosParceria: cifa.assistencia_tecnica_parceria_beneficiarios_atendidos?.toString() || '',
        docParceriaUuid: cifa.assistencia_tecnica_documento_parceria_uuid || null,
        relatorioUuid: cifa.assistencia_tecnica_parceria_empaer_relatorio_documento_uuid || null,
        instituicoes: [
          ...(cifa.assistencia_tecnica_parceria_empaer ? ['empaer'] : []),
          ...(cifa.assistencia_tecnica_parceria_instituicoes_ensino ? ['ensino'] : []),
          ...(cifa.assistencia_tecnica_parceria_ongs ? ['ongs'] : []),
          ...(cifa.assistencia_tecnica_parceria_outras ? ['privadas'] : []),
        ],
        outraInstituicao: cifa.assistencia_tecnica_parceria_outras_nome || '',
        relatorioUuid_empaer: cifa.assistencia_tecnica_parceria_empaer_relatorio_documento_uuid || null,
        relatorioUuid_ensino: cifa.assistencia_tecnica_parceria_instituicoes_ensino_relatorio_documento_uuid || null,
        relatorioUuid_ongs: cifa.assistencia_tecnica_parceria_ongs_relatorio_documento_uuid || null,
        relatorioUuid_privadas: cifa.assistencia_tecnica_parceria_outras_relatorio_documento_uuid || null,
      });
    }
  }, [cifa]);

  useEffect(() => {
    if (!cifa.uuid) {
      navigate(ROUTES[`CIFA${anoReferencia}` as keyof typeof ROUTES] as string);
    }
    // eslint-disable-next-line
  }, [cifa, anoReferencia, navigate]);

  const handleNext = (newAnswers?: AnswersType) => {
    if (newAnswers) setAnswers(newAnswers);
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => setActiveStep((prevStep) => prevStep - 1);

  return (
    <MenuProvider>
      <TopNavBar />
      <Header title={`CIFA - Cadastrar Município - ${anoReferencia}`} showBackButton={true} />
      <StepperHorizontal activeStep={activeStep} steps={steps} />
      {activeStep === 0 && (
        <Step1 onNext={(newAnswers: AnswersType) => handleNext(newAnswers)} initialData={answers} />
      )}
      {activeStep === 1 && (
        <Step2
          onNext={() => setActiveStep((prev) => prev + 1)}
          onBack={handleBack}
          step1Data={answers}
        />
      )}
    </MenuProvider>
  );
};

export default TechAssist;
